var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlobe = function SvgGlobe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B6B8BF",
    fillRule: "evenodd",
    d: "M12 4.417a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5m-9.75 8.25c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75-9.75-4.366-9.75-9.75",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B6B8BF",
    fillRule: "evenodd",
    d: "M12.469 3.081 12 3.667l-.469-.586a.75.75 0 0 1 .938 0M12 21.667l-.47.585-.001-.002-.005-.003-.012-.01-.041-.035-.138-.123a9 9 0 0 1-.466-.462c-.38-.405-.88-1.006-1.378-1.803-.998-1.597-1.989-3.983-1.989-7.147s.99-5.55 1.989-7.148c.498-.797.998-1.398 1.378-1.803a9 9 0 0 1 .604-.585l.04-.034.013-.01.005-.004.001-.001s.002-.001.47.585l.469-.586v.001l.002.001.005.004.012.01a3 3 0 0 1 .18.157c.115.105.275.26.465.462.38.405.88 1.006 1.378 1.803.999 1.598 1.989 3.984 1.989 7.148s-.99 5.55-1.989 7.147a11.8 11.8 0 0 1-1.378 1.803 9 9 0 0 1-.604.585l-.04.034-.013.01-.005.004-.001.001s-.002.001-.47-.584m0 0-.47.585a.75.75 0 0 0 .939 0zm0-1.035.039-.04c.323-.346.76-.87 1.2-1.573.877-1.402 1.761-3.516 1.761-6.352s-.884-4.95-1.761-6.353a10.3 10.3 0 0 0-1.2-1.572L12 4.701l-.039.041c-.323.345-.76.87-1.2 1.572C9.884 7.717 9 9.831 9 12.667s.884 4.95 1.761 6.352c.44.703.877 1.227 1.2 1.572zm.47-16.381",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B6B8BF",
    fillRule: "evenodd",
    d: "M2.762 9.667a.75.75 0 0 1 .75-.75h16.976a.75.75 0 0 1 0 1.5H3.512a.75.75 0 0 1-.75-.75M2.762 15.667a.75.75 0 0 1 .75-.75h16.976a.75.75 0 0 1 0 1.5H3.512a.75.75 0 0 1-.75-.75",
    clipRule: "evenodd"
  })));
};
export default SvgGlobe;